module.exports = __webpack_public_path__ + "img/alentour21.ff71f5e5.jpg";